const getSmsDefaultState = () => {
  return {
    smsList: [],
    campaign: {
      title: "",
      message: "",
      stores: [],
    },
    testPhone: "",
    formValidation: {
      title: { isValid: false, errorMessage: "" },
      message: { isValid: false, errorMessage: "" },
      stores: { isValid: false, errorMessage: "" },
    },
  };
};

const sms = {
  state: getSmsDefaultState(),
  mutations: {
    RESET_SMS_FORM(state) {
      state.campaign = {
        title: "",
        message: "",
        stores: [],
      };
      state.formValidation = {
        title: { isValid: false, errorMessage: "" },
        message: { isValid: false, errorMessage: "" },
        stores: { isValid: false, errorMessage: "" },
      };
    },
    GET_SMS_LIST(state, payload) {
      state.smsList = payload.sms || [];
    },
    ADD_SMS_CAMPAIGN(state, campaign) {
      state.smsList.unshift(campaign);
    },
    UPDATE_SMS_CAMPAIGN(state, updatedCampaign) {
      const index = state.smsList.findIndex(
        (item) => item.detail.chash === updatedCampaign.detail.chash
      );
      if (index !== -1) {
        state.smsList.splice(index, 1, updatedCampaign);
      }
    },
    SET_TEST_PHONE(state, phone) {
      state.testPhone = phone;
    },
    TOGGLE_STORE_SELECTION(state, storeHash) {
      const index = state.campaign.stores.indexOf(storeHash);
      if (index === -1) {
        state.campaign.stores.push(storeHash);
      } else {
        state.campaign.stores.splice(index, 1);
      }
    },
    UPDATE_SMS_FIELD(state, { field, value }) {
      state.campaign[field] = value;
    },
  },
  actions: {
    async getSmsList({ commit }) {
      commit("LOADING", { isActiveStatus: true });
      try {
        let { data } = await window.$http.axios.get("sms/getallitems");
        if (data.status) {
          commit("GET_SMS_LIST", data);
        } else {
          commit("NOTIFICATION_MESSAGE", {
            status: -1,
            title: "Error",
            message: data.message || "Failed to load SMS campaigns",
          });
        }
      } catch (error) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "SMS Load Error",
          message: error.message || "Failed to load SMS campaigns",
        });
      }
      commit("LOADING", { isActiveStatus: false });
    },

    async saveSmssCampaign({ state, commit }) {
      // Validation
      if (!state.campaign.title.trim()) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "Validation Error",
          message: "Campaign title is required",
        });
        return;
      }
      if (!state.campaign.message.trim()) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "Validation Error",
          message: "SMS message is required",
        });
        return;
      }
      if (state.campaign.stores.length === 0) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "Validation Error",
          message: "Please select at least one store",
        });
        return;
      }

      commit("LOADING", { isActiveStatus: true });
      try {
        const formData = new FormData();
        formData.append("c_title", state.campaign.title);
        formData.append("c_message", state.campaign.message);
        formData.append("c_stores", JSON.stringify(state.campaign.stores));

        let { data } = await window.$http.axios.post("sms/addsms", formData);
        if (data.status) {
          commit("ADD_SMS_CAMPAIGN", data.sms);
          commit("NOTIFICATION_MESSAGE", {
            status: 1,
            title: "Success",
            message: "SMS campaign created successfully",
          });
          commit("RESET_SMS_FORM");
          commit("RESET_MODALBOX");
        } else {
          commit("NOTIFICATION_MESSAGE", {
            status: -1,
            title: "Error",
            message: data.message || "Failed to create SMS campaign",
          });
        }
      } catch (error) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "SMS Save Error",
          message: error.message || "Failed to create SMS campaign",
        });
      }
      commit("LOADING", { isActiveStatus: false });
    },

    async sendTestSms({ state, commit }, campaign) {
      commit("LOADING", { isActiveStatus: true });
      try {
        let { data } = await window.$http.axios.get(
          `sms/testsend?c=${campaign.detail.chash}&phone=${state.testPhone}`
        );
        if (data.status) {
          commit("NOTIFICATION_MESSAGE", {
            status: 1,
            title: "SMS",
            message: "Test SMS sent successfully",
          });
        } else {
          commit("NOTIFICATION_MESSAGE", {
            status: -1,
            title: "Error",
            message: data.message || "Failed to send test SMS",
          });
        }
      } catch (error) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "SMS Error",
          message: error.message || "Failed to send test SMS",
        });
      }
      commit("LOADING", { isActiveStatus: false });
    },

    async sendToStores({ commit }, campaign) {
      commit("LOADING", { isActiveStatus: true });
      try {
        let { data } = await window.$http.axios.get(
          `sms/sendallstores?ch=${campaign.detail.chash}`
        );
        if (data.status) {
          commit("NOTIFICATION_MESSAGE", {
            status: 1,
            title: "SMS",
            message: data.message || "SMS sent to store customers successfully",
          });
        } else {
          commit("NOTIFICATION_MESSAGE", {
            status: -1,
            title: "Error",
            message: data.message || "Failed to send SMS to stores",
          });
        }
      } catch (error) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "SMS Error",
          message: error.message || "Failed to send SMS to stores",
        });
      }
      commit("LOADING", { isActiveStatus: false });
    },

    async sendToBrand({ commit }, campaign) {
      commit("LOADING", { isActiveStatus: true });
      try {
        let { data } = await window.$http.axios.get(
          `sms/sendallbrand?ch=${campaign.detail.chash}`
        );
        if (data.status) {
          commit("NOTIFICATION_MESSAGE", {
            status: 1,
            title: "SMS",
            message: data.message || "SMS sent to brand customers successfully",
          });
        } else {
          commit("NOTIFICATION_MESSAGE", {
            status: -1,
            title: "Error",
            message: data.message || "Failed to send SMS to brand customers",
          });
        }
      } catch (error) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "SMS Error",
          message: error.message || "Failed to send SMS to brand customers",
        });
      }
      commit("LOADING", { isActiveStatus: false });
    },

    closeSmsModal({ commit }) {
      commit("RESET_SMS_FORM");
      commit("RESET_MODALBOX");
    },
  },
};

export default sms;
